import LightingParameterCommonComponent from "../common/lighting-parameter.component";

const LightingParameterComponent = () => {
    return <div>
        <LightingParameterCommonComponent />
    </div>
}

export default LightingParameterComponent;